import axios from "axios";

export default class UserClient {
  constructor(client) {
    this.access_token = localStorage.getItem("access_token");
    this.client = client;
    this.httpClient = "";
  }

  setToken(token) {
    this.access_token = "Bearer " + token;
    this.httpClient = axios.create({
      baseURL: `${process.env.VUE_APP_APIURL}/api/app/${this.client}`,
      headers: { Authorization: `${this.access_token}` }
    });
  }

  async login(params) {
    return this.httpClient.post("login", params).then(res => res.data);
  }

  async logout() {
    return this.httpClient.post("logout", {});
  }

  async getDetail() {
    return this.httpClient.get(`${this.client}-detail`).then(res => res.data);
  }

  async delete(params) {
    return this.httpClient.post("delete", params).then(res => res.data);
  }

  async changeMarketingAgree(params) {
    return this.httpClient
      .post("change-marketing", params)
      .then(res => res.data);
  }

  async addAccount(params) {
    return this.httpClient.post("account-add", params).then(res => res.data);
  }

  async addSecurityNumber(params) {
    return this.httpClient
      .post("add-security-number", params)
      .then(res => res.data);
  }
}
